import { api } from '../axios'
import type { ApiResponse, School } from '../../../types'

export const transferApplicationsApi = {
  /**
   * Admin/approver history list.
   * Backend expects Prisma enum values for status: PENDING | PROCESSING | CONFIRMED | REJECTED.
   * UI uses: pending | processing | approved | rejected.
   */
  getAll: (page = 1, limit = 10, status?: string) => {
    const qs = new URLSearchParams()
    qs.set('page', String(page))
    qs.set('limit', String(limit))
    if (status) {
      const s = String(status || '').trim().toLowerCase()
      const mapped =
        s === 'approved' ? 'CONFIRMED' :
        s === 'rejected' ? 'REJECTED' :
        s === 'processing' ? 'PROCESSING' :
        s === 'pending' ? 'PENDING' :
        String(status)
      qs.set('status', mapped)
    }
    return api.get<ApiResponse & { pagination: any }>(`/transfer-applications?${qs.toString()}`)
  },
  
  getById: (id: number) => 
    api.get<ApiResponse<any>>(`/transfer-applications/${id}`),
  
  getByTeacherId: (teacherId: number) => 
    api.get<ApiResponse<any[]>>(`/transfer-applications/teacher/${teacherId}`),
  
  // Get current user's transfer applications (uses authenticated user's ID)
  getMyApplications: () => 
    api.get<ApiResponse<any[]>>(`/transfer-applications/my-applications`),
  
  create: (data: any) => 
    api.post<ApiResponse<any>>('/transfer-applications', data),
  
  updateStatus: (id: number, status: string) => 
    api.put<ApiResponse<any>>(`/transfer-applications/${id}/status`, { status }),
  
  getApprovalHistory: (id: number) => 
    api.get<ApiResponse<any[]>>(`/transfer-applications/${id}/approval-history`),
  
  getSchoolsForTransfer: () => 
    api.get<ApiResponse<School[]>>('/transfer-applications/schools-for-transfer'),
  
  /** Approvers: same rules as /approvals/my-applications (workflow + assignment + skips) */
  getPendingApprovalCount: () =>
    api.get<ApiResponse & { data: { count: number } }>('/approvals/pending-count'),

  /** Teachers: legacy pending list (PENDING status only) — prefer getTeacherNotificationCount for sidebar */
  getPendingCountAsTeacher: () =>
    api.get<ApiResponse & { pagination: { total: number } }>('/transfer-approver/pending?page=1&limit=1'),

  /** Teachers: sidebar badge — pending applications + transfer orders awaiting joining report */
  getTeacherNotificationCount: () =>
    api.get<ApiResponse & { data: { count: number } }>('/transfer-applications/teacher-notification-count'),

  /** Teachers: after viewing transfer lists — clears badge for unseen admin-initiated transfers */
  markAdminInitiatedSeen: () =>
    api.post<ApiResponse & { data: { updated: number } }>('/transfer-applications/mark-admin-initiated-seen')
}

export const transferOrdersApi = {
  /** Applications approved by minister but without generated transfer order. */
  getApprovedApplicationsWithoutOrders: (page = 1, limit = 10) =>
    api.get<ApiResponse<any[]> & { pagination?: { totalCount?: number; total?: number } }>(
      `/transfer-orders/approved-applications?page=${page}&limit=${limit}`
    ),
}

